import { render, staticRenderFns } from "./StudentServices.vue?vue&type=template&id=e4d4899c&"
import script from "./StudentServices.vue?vue&type=script&lang=js&"
export * from "./StudentServices.vue?vue&type=script&lang=js&"
import style0 from "./StudentServices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports